import { IMarker } from "shared/types";

export const mapMarkersToGeoJson = (
  markers: IMarker[]
): GeoJSON.FeatureCollection<GeoJSON.Geometry> => {
  const features = markers.map(
    ({ coordinates, id }): GeoJSON.Feature<GeoJSON.Geometry, GeoJSON.GeoJsonProperties> => ({
      type: "Feature",
      properties: {
        id,
      },
      geometry: {
        type: "Point",
        coordinates: [coordinates.longitude, coordinates.latitude],
      },
    })
  );
  return {
    type: "FeatureCollection",
    features,
  };
};
